import { Inject, Injectable } from "@angular/core";

import { AuthenticationProvider, Client } from "@microsoft/microsoft-graph-client";

@Injectable({
  providedIn: 'root'
})
export class MicrosoftGraphService {
  private _client: Client;

  constructor(
    @Inject('AUTH_PROVIDER') authProvider: AuthenticationProvider
  ) {
    this._client = Client.initWithMiddleware({ authProvider });
  }

  get client(): Client {
    return this._client;
  }
}
